var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 2 Copy",
    opacity: 0.518059,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5929 42.5462C34.5929 42.5462 32.8284 42.4435 36.7359 40.6932C40.6435 38.9429 47.8157 23.7466 40.0485 19.9222C32.2812 16.0979 39.5445 8.42581 36.8259 4.08661C34.1073 -0.252582 31.169 -0.628557 24.7197 3.65811C18.2704 7.94478 5.82846 -3.5045 1.47187 5.58403C-2.88472 14.6725 4.51543 3.63808 4.51543 3.63808L22.6607 9.34638L34.1047 19.3673L34.5929 42.5462Z",
    fill: "url(#paint0_linear_1_376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_376",
    x1: 12.7711,
    y1: 43.2224,
    x2: 29.3651,
    y2: -25.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD749B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#281AC8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.f6e33315de50d9a93acfaa8f21d61ede.svg";
export { ForwardRef as ReactComponent };